import { render, staticRenderFns } from "./PlaylistPagination.vue?vue&type=template&id=679e0be9"
import script from "./PlaylistPagination.vue?vue&type=script&lang=js"
export * from "./PlaylistPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports